import { render, staticRenderFns } from "./meetingMobileDetail.vue?vue&type=template&id=b8871dfa&scoped=true"
import script from "./meetingMobileDetail.vue?vue&type=script&lang=js"
export * from "./meetingMobileDetail.vue?vue&type=script&lang=js"
import style0 from "./meetingMobileDetail.vue?vue&type=style&index=0&id=b8871dfa&prod&lang=css"
import style1 from "./meetingMobileDetail.vue?vue&type=style&index=1&id=b8871dfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8871dfa",
  null
  
)

export default component.exports